<template>
  <div>
    <div class="contents-row">
        <!-- 타이틀 시작 -->
        <div class="page-title-1depth">
          <span class="page-title-1depth-text">{{$t('sm.adminGeneralSettings_accountSecuritySetting')}}</span>
        </div>
        <!-- 타이틀 끝 -->
      </div>

      <div class="contents-row">
        <!-- 컨텐츠 패널 시작 -->
        <div class="portlet">
          <div class="contents-row">
            <!-- 테이블 시작 -->
            <table class="bs-table table-bordered">
              <colgroup>
                <col width="25%"/>
                <col width="40px"/>
                <col width="auto"/>
              </colgroup>
              <tbody>
                <!--<tr v-if="adminGeneral.admin_type !== 3">-->
                <tr v-if="adminGeneral.admin_type !== 3">
                  <td class="td-head">{{$t('sm.adminGeneralSettings_accountValidePeriod')}} <span class="textR">*</span></td>
                  <td></td>
                  <td>
                    <div class="inline-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->
                      <q-datetime v-model="adminDetail.admin_valid_start_date" :disable="isReadOnly"
                                  type="date" :max="adminDetail.admin_valid_end_date"
                                  class="bs bs-q-datetime bs-q-datetime-default" style="width:120px">
                      </q-datetime>
                      <q-datetime name='value' v-model="adminDetail.admin_valid_end_date" :disable="isReadOnly"
                                  type="date" :min="adminDetail.admin_valid_start_date"
                                  class="bs bs-q-datetime bs-q-datetime-default" style="width:120px">
                      </q-datetime>
                      <q-input class="bs bs-spinner bs-spinner-default" style="width:70px;" v-model="fnAdminValidTerm" disable>
                      </q-input>
                    </div>
                  </td>
                </tr>

                <tr v-if="!externalAuth && adminGeneral.admin_type !== 3">
                  <td class="td-head">{{$t('sm.adminGeneralSettings_accountExpire')}} <span class="textR">*</span></td>
                  <td></td>
                  <td>
                    <div class="inline-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->
                      <touch-spin v-model="adminDetail.admin_unuse_expire_dt"
                                  :min-value="1"
                                  :max-value="180"
                                  :default-value="90"
                                  :disable="isReadOnly"
                                  class="bs bs-q-input bs-q-input-default"
                                  style="width:80px;" />
                      <div class="contents-option-explain">
                        {{ $t('sm.adminGeneralSettings_msg_accountUnuseDays') }}
                      </div>
                    </div>
                  </td>
                </tr>

                <tr v-if="!externalAuth">
                  <td class="td-head">{{$t('sm.deviceConfig_deviceConfigSep_pass')}} <span class="textR">*</span></td>
                  <td></td>
                  <td>
                    <div class="inline-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->
                      <!-- <q-input name="value" class="bs bs-spinner bs-spinner-default" style="width:70px;" v-model="adminDetail.admin_pw_expire_term" />
                      <div class="contents-option-explain">일 후 만료</div> -->
                      <div class="contents-option-explain" style="margin-left: 2px; margin-right:10px;">{{$t('sm.adminGroupSetting_page_passwordExpirePeriod')}}</div>
                      <touch-spin v-model="adminDetail.admin_pw_expire_term"
                                  min-value="0"
                                  default-value="30"
                                  max-value="90"
                                  :minToolTipSuffix="$t('sm.adminGeneralSettings_msg_change_cycle_notification')"
                                  :disable="isReadOnly"
                                  class="bs bs-q-input bs-q-input-default"
                                  style="min-width:120px;width:120px;">
                      </touch-spin>
                      <div class="contents-option-explain">{{$t('cmn.day')}}</div>
                    </div>
                  </td>
                </tr>

                <tr v-if="!externalAuth && !ccFlag">
                  <td class="td-head">SECUI OTP <span class="textR">*</span></td>
                  <td></td>
                  <td>
                    <div class="inline-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->

                      <q-toggle v-model="adminDetail.admin_otp_enable_yn"
                                :disable="isReadOnly"
                                :true-value="1"
                                :false-value="0"
                                class="bs bs-q-toggle bs-q-toggle-default"/>
                      <!-- OTP 키 설정 -->
                      <q-btn :label="$t('cmn.setting')"
                             @click="onClickSecuiOtp"
                             color="primary"
                             outline="outline"
                             class="bs bs-q-btn-sm bs-q-btn-line">
                        <tool-tip :message="$t('sm.otpKeySetting')"></tool-tip>
                      </q-btn>
                      <!-- OTP 사용 메뉴 설정 -->
                      <q-btn color="primary"
                             outline="outline"
                             @click="onClickSecuiOtpMenu"
                             class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line">
                        <q-icon class="bs-q-btn-icon bs-q-btn-icon-setting-sm"></q-icon>
                        <tool-tip :message="$t('sm.otpUseMenuSetting')"></tool-tip>
                      </q-btn>

                      <q-btn color="primary" size="sm" round class="bs bs-q-btn-sm bs-q-btn-page-title">
                        <span class="page-title-1depth-img"></span>
                        <q-tooltip anchor="bottom middle" self="top left" :offset="[10, 10]"
                                   class="bs bs-q-tooltip bs-q-tooltip-default">
                          <div class="bs-q-tooltip-contents">
                            {{ $t('msg.changeOtpSettings') }}
                          </div>
                        </q-tooltip>
                      </q-btn>

                    </div>
                  </td>
                </tr>

                <template v-if="externalAuth">

                  <tr v-if="externalAuth">
                    <td class="td-head">{{$t('sm.externalAuthSettings_httpUagntCheck')}} <span class="textR">*</span></td>
                    <td>
                      <div class="inline-group">
                        <q-toggle class="bs bs-q-toggle bs-q-toggle-default"
                                  v-model="adminDetail.extern_auth_uagnt_use_yn"
                                  :true-value="1"
                                  :false-value="0"
                                  :disable="isReadOnly" />
                      </div>
                    </td>
                    <td>
                      <div class="inline-group">
                        <q-input class="bs bs-q-input bs-q-input-default"
                                 style="width:210px;"
                                 v-model="adminDetail.extern_auth_uagnt_val"
                                 name="extern_auth_uagnt_val"
                                 data-vv-scope="user"
                                 v-validate="adminDetail.extern_auth_uagnt_use_yn === 1 ? `required` : ''"
                                 :error="errors.has('group.extern_auth_uagnt_val')"
                                 maxLength="1024"
                                 :disable="isReadOnly || !adminDetail.extern_auth_uagnt_use_yn">
                          <tool-tip maxValue="1024"></tool-tip>
                        </q-input>
                      </div>
                    </td>
                  </tr>

                  <tr v-if="externalAuth">
                    <td class="td-head">{{$t('sm.externalAuthSettings_refererCheck')}} <span class="textR">*</span></td>
                    <td>
                      <div class="inline-group">
                        <q-toggle class="bs bs-q-toggle bs-q-toggle-default"
                                  v-model="adminDetail.extern_auth_referer_use_yn"
                                  :true-value="1"
                                  :false-value="0"
                                  :disable="isReadOnly" />
                      </div>
                    </td>
                    <td></td>
                  </tr>

                </template>

              </tbody>
            </table>
            <!-- 테이블 끝 -->
          </div>

        </div>
        <!-- 컨텐츠 패널 끝 -->
    </div>
    <admin-otp-popup ref="adminOtpPopup"
                     :isReadOnly="isReadOnly"
                     @confirm="onConfirmOtpKey"
    />
    <contents-dialog ref="contentsSetPopup"
                     :isReadOnly="isReadOnly"
                     :contents="otpMenu"
                     :title="$t('sm.otpUseMenuSetting')"
                     :footerBtnList="['confirm', 'cancel']"
                     :match-use-key="'admin_otp_menu_enable_yn'"
                     :match-id-key="'admin_otp_menu_id'"
                     :match-name-key="'admin_otp_menu_name'"
                     @apply="onConfirmOtpMenu"
    ></contents-dialog>

  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  // components
  import TouchSpin from '~/components/control/touchSpin/TouchSpin'
  import AdminOtpPopup from '~/pages/system/adminSettings/administratorPopup/adminOtpPopup'
  import ContentSetPopUp from '~/components/popUp/ContentSetPopUp'

  // stores
  const adminGroupSettingsHelpers = createNamespacedHelpers('system/adminSettings/adminGroupSettings')

  export default {
    name: 'AdminUserSecuriry',
    components: {
      TouchSpin,
      AdminOtpPopup,
      'contents-dialog': ContentSetPopUp
    },
    created () {
    },
    props: {
      isBtnSave: {
        type: Boolean,
        default: false
      },
      isReadOnly: {
        type: Boolean,
        default: false
      },
      externalAuth: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...adminGroupSettingsHelpers.mapState([
        'adminGeneral',
        'adminDetail',
        'generalConfig',
        'adminOtpMenu'
      ]),
      ccFlag () {
        try {
          return this.$store.state.common.common.uiData.system.cc_flag
        } catch (e) {
          return false
        }
      },
      // 일수 계산
      fnAdminValidTerm () {
        const startDt = new Date(this.adminDetail.admin_valid_start_date)
        const endDt = new Date(this.adminDetail.admin_valid_end_date)
        const dif = endDt - startDt
        this.admin_valid_term = Math.ceil(dif / (1000 * 3600 * 24))
        return this.admin_valid_term
      }
    },
    data () {
      return {
        admin_valid_term: 0,
        otpMenu: []
      }
    },
    methods: {
      ...adminGroupSettingsHelpers.mapActions([
        'acsGetAdminGeneral',
        'getAdminOtpMenu',
        'updateAdminOtpMenu'
      ]),
      onSave () {
        this.$emit('onSave')
      },
      // OTP KEY 입력 팝업
      onClickSecuiOtp () {
        // secui otp
        this.$refs.adminOtpPopup.show(this.adminDetail.admin_otp_key)
      },
      // SECUI OTP 설정 메뉴
      async onClickSecuiOtpMenu () {
        try {
          if (typeof this.$refs.contentsSetPopup === 'undefined') {
            return
          }

          const res = await this.getAdminOtpMenu({ adminId: this.adminGeneral.admin_id })
          if (res.code === 'ok') {
            this.otpMenu = _.map(res.result, menu => {
              // 로그인 (항상 체크, 비활성화)
              if (menu.admin_otp_menu_id === 1) {
                menu.admin_otp_menu_enable_yn = 1
                menu.disabled = true
              }
              return menu
            })

            this.$nextTick(() => {
              this.$refs.contentsSetPopup.show()
            })
          }
        } catch (e) {
          this.$log('[Admin User Security GUI Error (onClickSecuiOtpMenu)]', e)
        }
      },
      compareOtpMenu (menu, targetMenu) {
        try {
          if (_.get(menu, ['length'], 0) !== _.get(targetMenu, ['length'], 0)) {
            return false
          }

          // 메뉴 리스트 정렬순서는 동일하다고 가정
          const otpMenuPick = ['admin_otp_menu_enable_yn', 'admin_otp_menu_id', 'admin_otp_menu_name']
          return menu.every((item, idx) => {
            const targetItem = targetMenu[idx]
            return otpMenuPick.every(key => {
              if (key === 'admin_otp_menu_enable_yn') {
                return Boolean(item[key]) === Boolean(targetItem[key])
              } else {
                return item[key] === targetItem[key]
              }
            })
          })
        } catch (e) {
          this.$log('[My Account Settings Error (onConfirmOtpKey)]', e)
        }
        return true
      },
      async onConfirmOtpMenu ({ listData }) {
        try {
          if (_.get(listData, ['length'], 0) > 0 &&
            !this.compareOtpMenu(this.otpMenu, listData)) {
            const res = await this.updateAdminOtpMenu({
              adminId: this.adminGeneral.admin_id,
              otpMenu: listData
            })
            if (res.code === 'ok') {
              this.$refs.contentsSetPopup.hide()
            } else {
              const globalAlertDialog = this.$store.state.common.common.components.alertDialog
              globalAlertDialog.show(res.result.msg, 'error')
            }
          }
        } catch (e) {
          this.$log('[Admin User Security GUI Error (onConfirmOtpMenu)]', e)
        }
      },
      onConfirmOtpKey (adminOtpKey) {
        try {
          if (_.get(adminOtpKey, ['length'], 0) > 0) {
            this.adminDetail.admin_otp_key = adminOtpKey
          }
        } catch (e) {
          this.$log('[My Account Settings Error (onConfirmOtpKey)]', e)
        }
      }
    },
    watch: {}
  }
</script>

<style scoped>
</style>

